import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { usePWAInstall } from '../../hooks/usePWAInstall';
import { requestInstallPrompt } from '../pwa/PWAInstallPrompt';
import Avatar from '../ui/Avatar';
import Icon from '../ui/Icon';

// Cada rol ve solo las opciones que hoy tienen una pantalla real detrás:
// nada de links rotos ni "Próximamente" — se prefiere un menú corto y
// funcional a uno grande y aspiracional.
const ADMIN_NAV = [
  { to: '/admin', label: 'Inicio', icon: 'home', end: true },
  { to: '/admin/solicitudes', label: 'Solicitudes', icon: 'clipboard' },
  { to: '/admin/aplicaciones', label: 'Aplicaciones', icon: 'clipboard' },
  { to: '/admin/fertilizantes', label: 'Fertilizantes', icon: 'droplet' },
  { to: '/admin/encargados', label: 'Encargados', icon: 'user' },
];

const ENCARGADO_NAV = [
  { to: '/', label: 'Inicio', icon: 'home', end: true },
  { to: '/aplicaciones', label: 'Aplicaciones', icon: 'clipboard' },
  { to: '/fertilizantes', label: 'Fertilizantes', icon: 'droplet' },
];

function AppDrawer({ onNavigate }) {
  const { isAdmin, admin, encargado, productor, signOut } = useAuth();
  const { installable, installed } = usePWAInstall();

  const navItems = isAdmin ? ADMIN_NAV : ENCARGADO_NAV;
  const showInstalar = installable && !installed;
  const nombre = isAdmin ? admin?.nombre : encargado?.nombre;
  const contexto = isAdmin ? 'Administrador' : productor?.nombre;

  return (
    <div className="flex h-full flex-col">
      <div className="px-5 pb-5 pt-6">
        <p className="text-lg font-bold text-gray-900">Family Growers</p>
        {isAdmin && <p className="text-sm text-gray-500">Administración</p>}

        <div className="mt-4 flex items-center gap-3">
          <Avatar nombre={nombre} />
          <div className="min-w-0">
            <p className="truncate text-sm font-medium text-gray-900">{nombre}</p>
            <p className="truncate text-xs text-gray-500">{contexto}</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-2">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={onNavigate}
            className={({ isActive }) =>
              `flex min-h-[48px] items-center gap-3 rounded-xl px-3 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500 ${
                isActive ? 'bg-green-50 text-green-700' : 'text-gray-600 hover:bg-gray-50'
              }`
            }
          >
            <Icon name={item.icon} className="h-5 w-5" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-gray-100 px-3 py-4">
        {showInstalar && (
          <button
            type="button"
            onClick={() => {
              onNavigate?.();
              requestInstallPrompt();
            }}
            className="flex min-h-[48px] w-full items-center gap-3 rounded-xl px-3 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500"
          >
            <Icon name="install" className="h-5 w-5" />
            Instalar aplicación
          </button>
        )}
        <button
          type="button"
          onClick={signOut}
          className="flex min-h-[48px] w-full items-center gap-3 rounded-xl px-3 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500"
        >
          <Icon name="logout" className="h-5 w-5" />
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}

export default AppDrawer;
